import React, { useEffect, useMemo } from 'react';
import Loadable from '@/components/common/loadable';
import HeadingCenter from '@/components/common/heading-center';
import { ticketPage } from '@/components/common/heading-center/breadcrumb-config';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getTicketDetail } from '../../../store/actions/ticket';
import { Skeleton } from 'antd';

const Information = Loadable({
  loader: () => import('./information'),
});
const Survey = Loadable({
  loader: () => import('./survey'),
});
const Thread = Loadable({
  loader: () => import('./thread'),
});
const Response = Loadable({
  loader: () => import('./response'),
});

export default () => {
  const id = useMemo(() => +location.pathname?.split('/').pop(), [location.pathname]);
  const { item, isLoading } = useSelector((state) => {
    const { item, isLoading } = state.ticket;
    return { item, isLoading };
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTicketDetail(id));
  }, []);

  if (isLoading) return <Skeleton loading />;

  return (
    <>
      <HeadingCenter pageConfig={ticketPage} />
      <div className="ticket-detail">
        {/** START: Information */}
        <Information item={item} />
        {/** END: Information */}

        {/** START: Survey */}
        <Survey item={item} />
        {/** END: Survey */}

        {/** START: Thread */}
        <Thread item={item} />
        {/** END: Thread */}

        {/** START: Response */}
        <Response item={item} />
        {/** END: Response */}
      </div>
    </>
  );
};
